import {
  CreateOrganizationRqDto,
  CreateOrganizationRsDto,
  DeleteOrganizationRqDto,
  DeleteOrganizationRsDto,
  GetOrganizationListRqDto,
  GetOrganizationListRsDto,
  GetOrganizationRqDto,
  GetOrganizationRsDto,
  UpdateOrganizationRqDto,
  UpdateOrganizationRsDto,
  Organization,
} from './../../../../../Models/Organization/Organization';
import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private controllerUrl = `${environment.baseUrl}/Organization`;

  constructor(private http: HttpRequestService) {}

  public async getOrganizationList(
    request: GetOrganizationListRqDto,
    isBlocking = false
  ): Promise<Array<Organization>> {
    return new Promise<Array<Organization>>(async (resolve, reject) => {
      let serviceResponse: Array<Organization> = [];

      await this.http
        .request<GetOrganizationListRsDto>(
          `${this.controllerUrl}/List`,
          request,
          'GET',
          isBlocking
        )
        .then((response) => {
          if (response.status === 200) {
            serviceResponse = response.body.Organizations;
          } else {
            return reject(response.error);
          }

          resolve(serviceResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public async getOrganization(
    request: GetOrganizationRqDto,
    isBlocking = false
  ): Promise<Organization> {
    return new Promise<Organization>(async (resolve, reject) => {
      let serviceResponse: Organization = null;

      await this.http
        .request<GetOrganizationRsDto>(
          `${this.controllerUrl}`,
          request,
          'GET',
          isBlocking
        )
        .then((response) => {
          if (response.status === 200) {
            serviceResponse = response.body;
          } else {
            return reject(response.error);
          }

          resolve(serviceResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public async createOrganization(
    request: CreateOrganizationRqDto,
    isBlocking = false
  ): Promise<CreateOrganizationRsDto> {
    return new Promise<CreateOrganizationRsDto>(async (resolve, reject) => {
      let serviceResponse = null;

      await this.http
        .request<CreateOrganizationRsDto>(
          `${this.controllerUrl}`,
          request,
          'POST',
          isBlocking
        )
        .then((response) => {
          if (response) {
            serviceResponse = response;
          } else {
            return reject(response.error);
          }

          resolve(serviceResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public async updateOrganization(
    request: UpdateOrganizationRqDto,
    isBlocking = false
  ): Promise<UpdateOrganizationRsDto> {
    return new Promise<UpdateOrganizationRsDto>(async (resolve, reject) => {
      let serviceResponse = null;

      await this.http
        .request<UpdateOrganizationRsDto>(
          `${this.controllerUrl}`,
          request,
          'PUT',
          isBlocking
        )
        .then((response) => {
          if (response) {
            serviceResponse = response.body;
          } else if (response?.error) {
            return reject(response.error);
          }

          resolve(serviceResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public async deleteOrganization(
    request: DeleteOrganizationRqDto,
    isBlocking = false
  ): Promise<DeleteOrganizationRsDto> {
    return new Promise<DeleteOrganizationRsDto>(async (resolve, reject) => {
      let serviceResponse = null;

      await this.http
        .request<DeleteOrganizationRsDto>(
          `${this.controllerUrl}`,
          request,
          'DELETE',
          isBlocking
        )
        .then((response) => {
          if (response.status === 200 || response.status === 204) {
            serviceResponse = response.body;
          } else {
            return reject(response.error);
          }

          resolve(serviceResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
